import { EnumItemModel } from './ItemModels';

export enum EAgeGroup {
  InfantOrToddlerAndPreschool = 1,
  KindergartenFirstGrades = 2,
  Elementary = 3,
  FromSixthToEighthGrades = 4
}

export const AgeGroupEnumItems:
  ReadonlyArray<EnumItemModel<EAgeGroup>> = [
    { text: 'Infant, Toddler & Preschool', value: EAgeGroup.InfantOrToddlerAndPreschool },
    { text: 'Kindergarten - 1st Grades', value: EAgeGroup.KindergartenFirstGrades },
    { text: 'Elementary', value: EAgeGroup.Elementary },
    { text: '6th - 8th Grades', value: EAgeGroup.FromSixthToEighthGrades }
  ];
